import { HiOutlineMagnifyingGlass } from "react-icons/hi2";

type TrackSearchProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  autoFocus?: boolean;
  onBlur?: () => void;
  onEscape?: () => void;
  className?: string;
};

export function TrackSearch({
  value,
  onChange,
  placeholder,
  autoFocus,
  onBlur,
  onEscape,
  className,
}: TrackSearchProps) {
  return (
    <div
      className={`relative min-w-[200px] flex h-[34px] items-center gap-2 rounded-full border border-[#DEE3EA] bg-white w-full py-1 pr-[5px] pl-2 ${className || ""}`}
    >
      <HiOutlineMagnifyingGlass className="w-5 h-5 text-[#525966] flex-shrink-0" />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        onKeyDown={(e) => {
          if (e.key === "Escape" && onEscape) {
            onEscape();
          }
        }}
        autoFocus={autoFocus}
        aria-label={placeholder || "Search tracks"}
        className="flex-1 h-full text-xs font-normal leading-[140%] text-[#878E9A] placeholder:text-[#878E9A] overflow-hidden text-ellipsis bg-transparent border-0 outline-none focus:outline-none"
      />
    </div>
  );
}
